/**
 * Sort patients by a given column and direction.
 * When sortColumn is null, returns the original array unchanged
 * (preserving the default pending-first ordering from the Patients page).
 */
export function sortPatients(rows, sortColumn, sortDirection) {
  if (!rows || rows.length === 0) return []
  if (!sortColumn) return rows

  return [...rows].sort((a, b) => {
    let valueA, valueB

    if (sortColumn === 'name' || sortColumn === 'physicianName') {
      valueA = a[sortColumn]?.toLowerCase() || ''
      valueB = b[sortColumn]?.toLowerCase() || ''
    } else {
      valueA = a[sortColumn]
      valueB = b[sortColumn]
    }

    if (valueA == null && valueB == null) return 0
    if (valueA == null) return sortDirection === 'asc' ? 1 : -1
    if (valueB == null) return sortDirection === 'asc' ? -1 : 1

    if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1
    if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1
    return 0
  })
}
